var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon, _polygon2, _path29, _path30, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 384.35 385.1",
    "data-imageid": "shopping-cart-monochromatic",
    imageName: "Shopping cart",
    className: "illustrations_image",
    style: {
      width: 121
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 219,
    y1: 295.76,
    x2: 216.19,
    y2: 394.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 251.37,
    y1: 173.73,
    x2: 242.93,
    y2: 159.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 287.9,
    y1: 207.51,
    x2: 263.5,
    y2: 261.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 291.04,
    y1: 232.54,
    x2: 303.14,
    y2: 232.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 261.96,
    y1: 238.72,
    x2: 286.2,
    y2: 260.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 340.95,
    y1: 175.33,
    x2: 227.46,
    y2: 168.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 243.26,
    y1: 332.16,
    x2: 264.4,
    y2: 332.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 309.16,
    y1: 331.44,
    x2: 322.71,
    y2: 331.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 291.23,
    y1: 193.63,
    x2: 273.49,
    y2: 159.28,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Empty Chart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M395.76,192.92q-9.36,43-18.73,85.94c-2.44,11.19-4.9,22.45-9.29,33a93,93,0,0,1-12.47,21.38c-15.41,19.88-38.58,33.82-63.55,37.22-15.92,2.17-32.19.34-48.08,2.71-20.06,3-38.58,12.52-58.39,16.85-28.28,6.19-58.22,1.43-85-9.61C79.16,371.72,43.07,356.1,29,333.26a38.59,38.59,0,0,1-5.51-14.39c-7-45.1,1.67-100.44,16.6-143.12,29-83,104.59-147.94,191-164.2,32.77-6.16,67.43-5.6,98.55,6.37S387.89,54.15,399,85.59C411.11,119.8,403.49,157.46,395.76,192.92Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#77d495",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M355.27,333.26c-15.41,19.88-38.58,33.82-63.55,37.22-15.92,2.17-32.19.34-48.08,2.71-20.06,3-38.58,12.52-58.39,16.85-28.28,6.19-58.22,1.43-85-9.61C79.16,371.72,43.07,356.1,29,333.26Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#77d495",
    className: "target-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.05,339.05c-32.2-7.46-65.78-4.4-98.68-1.31-3,.28-6.11.6-8.67,2.18s-4.35,4.85-3.26,7.66c1,2.47,3.66,3.73,6.18,4.57,16,5.41,33.36,4.12,50.23,3.35,54.66-2.48,110,1.2,163.59-10.09,5.46-1.15,11.3-2.7,14.81-7-10.05-5.11-22.17-3.71-33-.61s-21.31,7.81-32.51,9.05c-6.29.69-8.4-5.91-13.61-8.3-4-1.84-6.61-1.38-10.71-.14C232.71,342.23,224.2,342.1,211.05,339.05Z",
    transform: "translate(-20.99 -7.68)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.69,333.37a8.49,8.49,0,0,1-7-13.22h0a8.49,8.49,0,1,1,7,13.22Zm-2.89-10.43a3.49,3.49,0,1,0,4.85-.95,3.5,3.5,0,0,0-4.85.95Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#2e2e3f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.48,333.37a8.48,8.48,0,0,1-7-13.22h0a8.49,8.49,0,1,1,7,13.22Zm-2.88-10.43a3.49,3.49,0,1,0,4.84-.95,3.49,3.49,0,0,0-4.84.95Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#2e2e3f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241.09,157.11a10.8,10.8,0,0,1-1.31,2.79,11.14,11.14,0,0,1-4.14,3.07c-6.34,3.25-16,6.75-21.38,11.45a6.16,6.16,0,0,0-1.59,1.9c-.77,1.67,0,3.6.71,5.28a5.66,5.66,0,0,0,1.64,2.46c1.37,1,3.27.57,4.9.09a185,185,0,0,0,18.42-6.57,79.62,79.62,0,0,0,9.79-4.75,9.31,9.31,0,0,0,3.21-2.72,9.45,9.45,0,0,0,1.17-3.33,150.64,150.64,0,0,0,2.29-18.34L256,134c.24-2.78,8.7-12.51,6.15-14.42-5-3.74-12.27,6.44-13.41,8.53C245.52,134,242.34,153.55,241.09,157.11Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#77d495",
    className: "target-color"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.09,157.11a10.8,10.8,0,0,1-1.31,2.79,11.14,11.14,0,0,1-4.14,3.07c-6.34,3.25-16,6.75-21.38,11.45a6.16,6.16,0,0,0-1.59,1.9c-.77,1.67,0,3.6.71,5.28a5.66,5.66,0,0,0,1.64,2.46c1.37,1,3.27.57,4.9.09a185,185,0,0,0,18.42-6.57,79.62,79.62,0,0,0,9.79-4.75,9.31,9.31,0,0,0,3.21-2.72,9.45,9.45,0,0,0,1.17-3.33,150.64,150.64,0,0,0,2.29-18.34L256,134c.24-2.78,8.7-12.51,6.15-14.42-5-3.74-12.27,6.44-13.41,8.53C245.52,134,242.34,153.55,241.09,157.11Z",
    transform: "translate(-20.99 -7.68)",
    fill: "url(#linear-gradient-2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M318.75,313.51a7.94,7.94,0,0,1,1.21,4.31,4.1,4.1,0,0,1-5.19,3.27,7.41,7.41,0,0,1-2.42-1.62c-8.37-7.44-15-16.61-21-26.11-1.62-2.58-3.19-5.19-4.57-7.9a66,66,0,0,1-7.15-29.63,2.55,2.55,0,0,1,.41-1.68,2.38,2.38,0,0,1,1.27-.67c4.14-1.16,10.59-1.27,14.25,1.43,4.11,3,3.12,12.45,2.94,16.75a13,13,0,0,0,.54,5.45,13.87,13.87,0,0,0,3,4C310.43,290.12,313.34,302.61,318.75,313.51Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#f3bd8f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M266.85,293a85.54,85.54,0,0,1-4.53,34.48,5,5,0,0,1-1.54,2.59,3.44,3.44,0,0,1-3.47.08c-2.71-1.32-3.66-4.2-4.12-7a220.75,220.75,0,0,1-2.86-37.38c0-5.91.17-11.54-.29-17.42-.46-6.05-1.14-12.09-1.14-18.17a2.49,2.49,0,0,1,.32-1.75,2.32,2.32,0,0,1,1.89-.59c4.34,0,12.26-2.5,15.64.26,4.45,3.63-2.67,19.59-3.38,24.21-1.19,7.71,2.16,10,3.15,17.61C266.65,291,266.76,292,266.85,293Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#f5bd8d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M245,250.25a5.28,5.28,0,0,0,.83,3.33,4.94,4.94,0,0,0,2.45,1.38c4.76,1.48,9.78,1.79,14.75,2.1,1.52.09,3.2.13,4.37-.83a6.12,6.12,0,0,0,1.57-2.54l5.52-13.51a118.36,118.36,0,0,0-.37,14.34,4.16,4.16,0,0,0,.85,2.86,4.1,4.1,0,0,0,2.82.84,104.37,104.37,0,0,0,22.87-1.66c2.92-10.77,3-22.16,1.55-33.22-.57-4.31-1.42-8.7-3.71-12.4a7.17,7.17,0,0,0-2.32-2.51,9.12,9.12,0,0,0-4.64-.87c-11.58-.12-23.34-.39-34.85,1.25-3.59.51-5.47,1.63-6.72,5.14a89.26,89.26,0,0,0-3.75,17A121.64,121.64,0,0,0,245,250.25Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#2e2e3f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M300.66,256.56l-1.8.31a104,104,0,0,1-21.07,1.35,4.1,4.1,0,0,1-2.82-.84,4.16,4.16,0,0,1-.85-2.86,116.44,116.44,0,0,1,.3-13.34c0-.11,0-.23,0-.34s0-.44.05-.66v0c-1.84,4.49-3.67,9-5.51,13.49a6.12,6.12,0,0,1-1.57,2.54c-1.17,1-2.85.92-4.37.83l-.69,0h0c-4.74-.3-9.51-.65-14-2.06a4.87,4.87,0,0,1-2.45-1.38,5.28,5.28,0,0,1-.83-3.33,121.64,121.64,0,0,1,1.22-19.35A89.26,89.26,0,0,1,250,214c1.25-3.51,3.13-4.63,6.72-5.14,11.51-1.64,23.27-1.37,34.85-1.25a10.19,10.19,0,0,1,4.24.66,3,3,0,0,1,.4.21,7.17,7.17,0,0,1,2.32,2.51c2.29,3.7,3.14,8.09,3.71,12.4C303.68,234.4,303.58,245.79,300.66,256.56Z",
    transform: "translate(-20.99 -7.68)",
    fill: "url(#linear-gradient-3)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M300.66,256.56l-1.8.31a14.07,14.07,0,0,1-1.25-.73,6.6,6.6,0,0,1-2.42-2.3,7.11,7.11,0,0,1-.62-3.1c-.33-8.92,1.37-18-.44-26.71-.65-3.14-1.95-6-2.88-9-.85-2.77,1.05-4.42,3.28-6a8.39,8.39,0,0,1,1.25-.77,3,3,0,0,1,.4.21,7.17,7.17,0,0,1,2.32,2.51c2.29,3.7,3.14,8.09,3.71,12.4C303.68,234.4,303.58,245.79,300.66,256.56Z",
    transform: "translate(-20.99 -7.68)",
    fill: "url(#linear-gradient-4)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M274.48,240.2c-1.84,4.49-3.67,9-5.51,13.49a6.12,6.12,0,0,1-1.57,2.54c-1.17,1-2.85.92-4.37.83l-.69,0h0a4.44,4.44,0,0,1-.73-.49,5.35,5.35,0,0,1-1.54-6,12.65,12.65,0,0,1,1.84-2.76c4.36-5.59,6.74-12.42,9.06-19.12a14.56,14.56,0,0,1,2.8,4.93A17.87,17.87,0,0,1,274.48,240.2Z",
    transform: "translate(-20.99 -7.68)",
    fill: "url(#linear-gradient-5)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M272.23,111a7.32,7.32,0,0,1-2,4.84c-1.84,1.66-4.63,1.56-6.94,2.49a1.93,1.93,0,0,0-.77.48,1.65,1.65,0,0,0-.35.7,5.85,5.85,0,0,0,.27,3.62,12.73,12.73,0,0,0,7.9,7.29,23.82,23.82,0,0,0,11,.77,8.24,8.24,0,0,0,3.48-1,8.63,8.63,0,0,0,2.63-3.3,10.76,10.76,0,0,0,1.41-3.87,4,4,0,0,0-1.46-3.69,8,8,0,0,0-1.62-.75,14.48,14.48,0,0,1-2.55-1.28,3.81,3.81,0,0,1-1.81-2,4.83,4.83,0,0,1,.09-2.2,20,20,0,0,0,0-7.36,6.86,6.86,0,0,0-.66-2.07,4.16,4.16,0,0,0-6.49-1C272,104.82,272.51,108.22,272.23,111Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#f3bd8f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M261.16,98.07a15.16,15.16,0,0,0,.41,4.94c1.18,3.83,5.23,6.3,9.24,6.46a7.37,7.37,0,0,0,3.82-.73,9,9,0,0,0,1.86-1.41c2.8-2.56,5.38-5.62,6.23-9.32a17.91,17.91,0,0,0,.36-4.27A16.62,16.62,0,0,0,282,87.56,11,11,0,0,0,273.39,81c-3.87-.49-7.5,1.47-10.33,3.9-1.42,1.22-1.21,3.62-1.39,5.45C261.42,92.9,261.25,95.49,261.16,98.07Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#f3bd8f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M261.64,76.74c-1.08,1.85-1.81,4-3.48,5.33-.69.54-1.5.93-2.14,1.52a4.94,4.94,0,0,0-.26,6.5,6.47,6.47,0,0,0,6.48,2,9.43,9.43,0,0,0,5.55-4.23c.83-1.3,1.57-2.88,3-3.36a4.14,4.14,0,0,1,3.63.91c1.05.76,1.93,1.76,3,2.44a13.62,13.62,0,0,1,1.83,1.13c1.72,1.49,1.46,4.18,1.06,6.42.72.22.86-1.07,1.49-1.48s1.36.19,1.47.86a3,3,0,0,1-.55,1.9c-1.64,2.87-3.58,5.69-4.13,8.94a2.24,2.24,0,0,0,.06,1.31,2.38,2.38,0,0,0,1.42,1,7.89,7.89,0,0,0,3.17.65,3.45,3.45,0,0,0,2.77-1.47,4.82,4.82,0,0,0,.55-1.87,44.67,44.67,0,0,1,.88-6.45c1.21-4.18,4.8-7.82,4.27-12.13a13.42,13.42,0,0,0-2.39-5.38,16.06,16.06,0,0,0-2.52-3.32,15.65,15.65,0,0,0-3.16-2.1,23.83,23.83,0,0,0-7.58-2.91c-3.17-.48-6,.55-9.1.7C264.52,73.76,263,74.35,261.64,76.74Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#2e2e3f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M297.91,211.85a14.45,14.45,0,0,1-6,2.41A80,80,0,0,1,257,214.2c-2.4-.55-5.07-1.43-6.11-3.67a8.51,8.51,0,0,1-.51-3.86q.41-18.54.82-37.09c.31-14.05.62-28.15,2.68-42.05a23.52,23.52,0,0,1,3.36-8.06c1.34-1.83,7.41-.85,12.48-4.13,1.39-.9-1.63,3.75,2.91,5.67,4.71,2,10-7.37,12.86-3.61,1.61,2.1,6.73.54,8.35,2.63,1.3,1.68,2.1,5.23,2.61,9.51,1.08,9.09.81,21.43,1,25.92.85,15.71-.47,35.75,4.72,48.72C303.36,207,300.25,210,297.91,211.85Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#77d495",
    className: "target-color"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M297.91,211.85a14.45,14.45,0,0,1-6,2.41,80.07,80.07,0,0,1-8.7,1.43l-.82-.11c2.14-7,2.24-14.36,2.18-21.64,0-4-.12-8.05-.2-12.07-.05-2.54-.14-5.21-1.45-7.38s-4.29-3.55-6.47-2.24c3.75-2.26,6.82-11.82,8.36-15.74a79,79,0,0,0,4.62-17.63c.58-4.14.36-11.42,6.7-9.46l.35.12c1.08,9.09.81,21.43,1,25.92.85,15.71-.47,35.75,4.72,48.72C303.36,207,300.25,210,297.91,211.85Z",
    transform: "translate(-20.99 -7.68)",
    fill: "url(#linear-gradient-6)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M262.08,324.3a1.42,1.42,0,0,1,.94.47,1.78,1.78,0,0,1,.17,1c0,2,1.27,3.81,1.2,5.79-.05,1.77-1.15,3.43-1,5.2,0,.35.09.76-.16,1a1.08,1.08,0,0,1-.57.24q-7.53,1.44-15.13,2.51a3.91,3.91,0,0,1-2.79-.3,2.86,2.86,0,0,1-.89-1.14c-1.37-2.79-.15-6.21,1.71-8.7C250.11,324.24,254.5,322.77,262.08,324.3Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#2e2e3f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M325.27,323.52a6.9,6.9,0,0,1-2.56,4,40.48,40.48,0,0,1-10.9,7.2,4.54,4.54,0,0,1-2.65.56,3.31,3.31,0,0,1-2.39-3.23,9.66,9.66,0,0,1,1.1-4.16c1.93-4.46,3.27-11,8.42-12.77C320.79,313.61,325.75,319.08,325.27,323.52Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#2e2e3f"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M262.08,324.3a1.42,1.42,0,0,1,.94.47,1.78,1.78,0,0,1,.17,1c0,2,1.27,3.81,1.2,5.79-.05,1.77-1.15,3.43-1,5.2,0,.35.09.76-.16,1a1.08,1.08,0,0,1-.57.24q-7.53,1.44-15.13,2.51a3.91,3.91,0,0,1-2.79-.3,2.86,2.86,0,0,1-.89-1.14c-1.37-2.79-.15-6.21,1.71-8.7C250.11,324.24,254.5,322.77,262.08,324.3Z",
    transform: "translate(-20.99 -7.68)",
    fill: "url(#linear-gradient-7)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M322.71,327.54a40.48,40.48,0,0,1-10.9,7.2,4.54,4.54,0,0,1-2.65.56",
    transform: "translate(-20.99 -7.68)",
    fill: "url(#linear-gradient-8)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M288.1,156a7.81,7.81,0,0,1-.39,3.72c-.72,1.65-2.39,2.65-4,3.54l-35.47,20.07c-1.66.94-3.44,2-4.15,3.78-1.56,4,3.33,7.59,7.58,7.91,4.45.33,8.83-1,13.05-2.47a227.76,227.76,0,0,0,38.46-17.4,6.91,6.91,0,0,0,4.4-7.67,183.42,183.42,0,0,0-2.24-29.24c-.83-5.29-2-10.82-5.57-14.83-5.28-6-14.92-6.18-15.75,2.61C283.1,136,287.43,146.18,288.1,156Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#77d495",
    className: "target-color"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M288.1,156a7.81,7.81,0,0,1-.39,3.72c-.72,1.65-2.39,2.65-4,3.54l-35.47,20.07c-1.66.94-3.44,2-4.15,3.78-1.56,4,3.33,7.59,7.58,7.91,4.45.33,8.83-1,13.05-2.47a227.76,227.76,0,0,0,38.46-17.4,6.91,6.91,0,0,0,4.4-7.67,183.42,183.42,0,0,0-2.24-29.24c-.83-5.29-2-10.82-5.57-14.83-5.28-6-14.92-6.18-15.75,2.61C283.1,136,287.43,146.18,288.1,156Z",
    transform: "translate(-20.99 -7.68)",
    fill: "url(#linear-gradient-9)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M239.53,186.66a10.09,10.09,0,0,0-6.9,2.7,6.17,6.17,0,0,0-1.3,7,3.38,3.38,0,0,0,1.85,1.68,3.66,3.66,0,0,0,2.17-.07c2-.61,3.65-2.16,5.61-3a2.27,2.27,0,0,1,1.53-.17,6.16,6.16,0,0,1,.94.59,3,3,0,0,0,2.7.09,5,5,0,0,0,2.06-1.85,5.34,5.34,0,0,0,1-3.46c-.2-1.9-1.3-2.51-2.94-2.7C244,187.23,241.84,186.58,239.53,186.66Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#f3bd8f"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M206.58,180.49a9.22,9.22,0,0,0-1.89,4,4.15,4.15,0,0,0,.07,2.1,3.63,3.63,0,0,0,3.43,2.18,8.36,8.36,0,0,0,4.09-1.27,52.56,52.56,0,0,0,6.53-4.45,5.13,5.13,0,0,0,1.13-1.05,3.22,3.22,0,0,0-.51-4C216.05,174.61,209.12,177.34,206.58,180.49Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#f3bd8f"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M174.52,296H90.24L57.53,206.9H199.89Zm-80.79-5h77l22.53-79.12H64.69Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#77d495",
    className: "target-color"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M207.78,296H123.49L90.79,206.9h144.8ZM127,291h77l22.53-79.12H98Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#77d495",
    className: "target-color"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M208.28,296.05H168.36L186.24,233,201,187.21l40.26.54Zm-33.31-5h29.61l30-98.39-29.92-.4L191,234.45Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#77d495",
    className: "target-color"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "187.21 313.27 89.49 313.27 89.49 308.27 182.21 308.27 182.21 285.84 187.21 285.84 187.21 313.27",
    fill: "#77d495",
    className: "target-color"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "154.5 313.27 74.94 313.27 74.94 308.27 149.5 308.27 149.5 285.84 154.5 285.84 154.5 313.27",
    fill: "#77d495",
    className: "target-color"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M192.08,333.37a8.49,8.49,0,1,1,8.49-8.49A8.49,8.49,0,0,1,192.08,333.37Zm0-12a3.49,3.49,0,1,0,3.49,3.49A3.49,3.49,0,0,0,192.08,321.39Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#2e2e3f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M131.43,333.37a8.48,8.48,0,0,1-7-13.22h0a8.49,8.49,0,1,1,7,13.22Zm-2.89-10.43a3.49,3.49,0,1,0,4.84-.95,3.5,3.5,0,0,0-4.84.95Z",
    transform: "translate(-20.99 -7.68)",
    fill: "#2e2e3f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.73,
    y: 217.08,
    width: 158.05,
    height: 3.77,
    fill: "#77d495",
    className: "target-color"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.11,
    y: 229.75,
    width: 150.54,
    height: 3.77,
    fill: "#77d495",
    className: "target-color"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.99,
    y: 242.42,
    width: 141.53,
    height: 3.77,
    fill: "#77d495",
    className: "target-color"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60.87,
    y: 255.09,
    width: 132.52,
    height: 3.77,
    fill: "#77d495",
    className: "target-color"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65.75,
    y: 267.76,
    width: 123.51,
    height: 3.77,
    fill: "#77d495",
    className: "target-color"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 90.3,
    y: 206.31,
    width: 3.77,
    height: 88.72,
    transform: "translate(-101.32 39.1) rotate(-20.04)",
    fill: "#77d495",
    className: "target-color"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 131.12,
    y: 207.26,
    width: 3.77,
    height: 85.71,
    transform: "translate(-86.23 40.08) rotate(-16.41)",
    fill: "#77d495",
    className: "target-color"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 157.31,
    y: 207.85,
    width: 3.77,
    height: 83.95,
    transform: "translate(-29.27 -2.2) rotate(-1.92)",
    fill: "#77d495",
    className: "target-color"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 149.12,
    y: 249.91,
    width: 86.03,
    height: 3.77,
    transform: "translate(-126.05 353.61) rotate(-72.88)",
    fill: "#77d495",
    className: "target-color"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompra);
export default __webpack_public_path__ + "static/media/compra.ca244b0d8c33b9ed9d4976c70342cd63.svg";
export { ForwardRef as ReactComponent };